var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    fill: "#6DFFBD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.4015 58.277C95.8963 58.277 99.54 54.6332 99.54 50.1385C99.54 45.6437 95.8963 42 91.4015 42C86.9068 42 83.2631 45.6437 83.2631 50.1385C83.2631 54.6332 86.9068 58.277 91.4015 58.277Z",
    fill: "#FF7FFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3652 65.5208H85.4922V76.3938H96.3652V65.5208Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3652 86.2568H85.4922V97.1299H96.3652V86.2568Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6191 65.5208H63.7461V76.3938H74.6191V65.5208Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6191 44.7041H63.7461V55.5771H74.6191V44.7041Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6191 86.2568H63.7461V97.1299H74.6191V86.2568Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.873 65.5208H42V76.3938H52.873V65.5208Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.873 44.7041H42V55.5771H52.873V44.7041Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.873 86.2568H42V97.1299H52.873V86.2568Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Svg);
export default __webpack_public_path__ + "static/media/3_svg.057846f760df8536c93e7ab5afe04372.svg";
export { ForwardRef as ReactComponent };